import { createApp } from 'vue';
import './firebase/config';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './index.css';
import './registerServiceWorker';

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');